export const MAX_SUBMITTALS = 100000;

export const SCENARIOS = [
  { title: "Minimal to zero impact", desc: "Rejection causes no impact to project.", cost: "0", share: "25" },
  { title: "Workflow adjustment", desc: "Sequencing change or alternate selection; ~2 hours of coordination.", cost: "500", share: "65" },
  { title: "Delay + rework", desc: "Field or detailing rework; extra labour and overhead.", cost: "2000", share: "9" },
  { title: "Major project delay", desc: "Delays completion; may trigger liquidated damages.", cost: "30000", share: "1" },
];

export const defaultInputs = () => ({
  submittals: "2000",
  rate: 30,
  condoorRate: "5",
  manualHours: "80",
  condoorHours: "2",
  scenarios: SCENARIOS.map((s) => ({ ...s })),
});

export const num = (v) => {
  const n = parseFloat(String(v ?? "").replace(/,/g, ""));
  return Number.isFinite(n) && n > 0 ? n : 0;
};

export const computeRoi = (s) => {
  const n = Math.min(num(s.submittals), MAX_SUBMITTALS);
  const avgCost = s.scenarios.reduce((a, x) => a + (num(x.cost) * num(x.share)) / 100, 0);
  const shareTotal = s.scenarios.reduce((a, x) => a + num(x.share), 0);
  const delta = Math.max(0, num(s.rate) - num(s.condoorRate)) / 100;
  const manual = num(s.manualHours);
  const timeSaved = manual > 0 ? Math.max(0, 1 - num(s.condoorHours) / manual) * 100 : 0;
  return { saved: n * delta * avgCost, timeSaved, avgCost, shareTotal };
};

export const fmt = (n) => Math.round(n).toLocaleString("en-US");
export const fmtPct = (n) => `${(Math.round(n * 10) / 10).toFixed(1).replace(/\.0$/, "")}%`;
